import { Suspense, type ReactNode } from 'react'
import { CardSkeleton } from '@/components/ui/Skeleton'

export function AdminRouteFallback() {
  return (
    <div className="space-y-4">
      <CardSkeleton />
      <CardSkeleton />
    </div>
  )
}

export function AdminSuspenseOutlet({ children }: { children: ReactNode }) {
  return <Suspense fallback={<AdminRouteFallback />}>{children}</Suspense>
}
